import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import { Fade, useMediaQuery } from "@material-ui/core";
import openSocket from "../../services/socket-io";
import TicketTags from "../TicketTags";
import WhatsappLabels from "../WhatsappLabels";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput/";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtons";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const Ticket = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {
          const { data } = await api.get("/tickets/" + ticketId);

          setContact(data.contact);
          setTicket(data);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, history]);

  useEffect(() => {
    const socket = openSocket();

    socket.on("connect", () => socket.emit("joinChatBox", ticketId));

    socket.on("ticket", (data) => {
      if (data.action === "update" && Number(data.ticket.id) === Number(ticketId)) {
        setTicket(data.ticket);
      }

      if (data.action === "delete" && Number(data.ticketId) === Number(ticketId)) {
        toast.success("Ticket deleted sucessfully.");
        history.push("/tickets");
      }
    });

    socket.on("contact", (data) => {
      if (data.action === "update") {
        setContact((prevState) => {
          if (prevState.id === data.contact?.id) {
            return { ...prevState, ...data.contact };
          }
          return prevState;
        });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [ticketId, history]);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <Fade in timeout={reduceMotion ? 0 : 200}>
    <div className="tw-relative tw-flex tw-h-full tw-min-h-0 tw-min-w-0 tw-flex-col tw-overflow-hidden" id="drawer-container">
        <TicketHeader loading={loading}>
          <div className="tw-flex tw-min-w-0 tw-flex-1">
            <TicketInfo
              contact={contact}
              ticket={ticket}
              onClick={handleDrawerOpen}
            />
          </div>
          <div className="tw-flex tw-shrink-0">
            <TicketActionButtons ticket={ticket} onContact={handleDrawerOpen} />
          </div>
        </TicketHeader>
        {!loading && (
          <div className="tw-hidden tw-min-h-[38px] tw-shrink-0 tw-items-center tw-gap-2 tw-overflow-x-auto tw-border-0 tw-border-b tw-border-solid tw-border-slate-100 tw-bg-white tw-px-5 tw-py-1 sm:tw-flex dark:tw-border-slate-700 dark:tw-bg-[#172b22]">
            <span className="tw-rounded-full tw-bg-slate-100 tw-px-2 tw-py-1 tw-text-xs dark:tw-bg-slate-700">#{ticket.id}</span>
            <WhatsappLabels labels={ticket.labels} limit={2} />
            <TicketTags ticket={ticket} compact />
          </div>
        )}
        <ReplyMessageProvider>
          <MessagesList
            ticketId={ticketId}
            isGroup={ticket.isGroup}
          ></MessagesList>
          <MessageInput
            ticketStatus={ticket.status}
            ticketQueueId={ticket.queueId}
          />
        </ReplyMessageProvider>
      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        ticket={ticket}
        loading={loading}
      />
    </div>
    </Fade>
  );
};

export default Ticket;
